import { useEffect, useRef, useState } from "react";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import { useNavigate } from "react-router-dom";
import categoryService from "../../services/CategoryService";

export default function CategoriesAddPage() {
    const [mounted, setMounted] = useState(false);
    useEffect(() => { setMounted(true); }, []);
  const [category, setCategory] = useState({
    name: "",
    description: "",
  });
  const [saving, setSaving] = useState(false);
  const toast = useRef(null);
  const navigate = useNavigate();

  const handleChange = (field, value) => {
    setCategory({ ...category, [field]: value });
  };

  const handleSave = async () => {
    if (!category.name.trim()) {
        toast.current.show({ severity: 'warn', summary: 'Uyarı', detail: 'Kategori adı boş olamaz!' });
        return;
    }

    try {
      setSaving(true);
      await categoryService.create(category);
      toast.current.show({ severity: 'success', summary: 'Başarılı', detail: 'Kategori başarıyla eklendi.' });
      setTimeout(() => navigate(`/categories`), 700);
    } catch (err) {
      toast.current.show({ severity: 'error', summary: 'Hata', detail: 'Kategori kaydedilirken bir hata oluştu.' });
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="p-2 md:p-4 animate-fade-in bg-[#f8fafc] min-h-screen">
      <Toast ref={toast}  appendTo={mounted ? document.body : "self"} />

      <div className="max-w-3xl mx-auto">
        <div className="bg-white shadow-lg shadow-slate-200/50 border border-slate-200 rounded-2xl overflow-hidden">
          {/* Header */}
          <div className="bg-slate-50/50 border-b border-slate-200 p-4 md:p-6 flex items-center justify-between">
            <div className="flex items-center gap-4">
              <div className="bg-emerald-600 p-3 rounded-xl shadow-md shadow-emerald-500/20">
                <i className="pi pi-plus text-white text-xl"></i>
              </div>
              <div>
                <h1 className="text-xl md:text-2xl font-black text-slate-900 uppercase tracking-tight">Yeni Kategori</h1>
                <div className="flex items-center gap-2 mt-0.5">
                  <span className="px-2 py-0.5 bg-emerald-50 text-emerald-600 text-[9px] font-black rounded-lg uppercase border border-emerald-100">KAYIT</span>
                  <span className="text-slate-400 text-xs font-medium">• Yeni ürün grubu tanımla</span>
                </div>
              </div>
            </div>

            <div className="flex gap-2">
              <Button
                label="GERİ"
                icon="pi pi-arrow-left"
                className="p-button-text text-slate-400 font-black text-sm hover:bg-slate-100 rounded-xl px-4 py-2"
                onClick={() => navigate("/categories")}
              />
              <Button
                label="KAYDET"
                icon="pi pi-check"
                loading={saving}
                className="!bg-emerald-600 border-none hover:!bg-emerald-700 rounded-xl px-6 py-3 font-black text-sm shadow-lg !shadow-emerald-600/20 transition-all hover:scale-[1.02]"
                onClick={handleSave}
              />
            </div>
          </div>

          {/* Form Content */}
          <div className="p-6 md:p-8 space-y-6">
            <div className="grid grid-cols-1 gap-6">
              <div className="space-y-2">
                <label className="text-[10px] text-slate-400 font-black uppercase tracking-wider block ml-1">Kategori Adı</label>
                <InputText
                  value={category.name}
                  placeholder="Örn: İçecekler"
                  className="w-full border-slate-200 rounded-xl focus:border-emerald-500 py-3 shadow-sm font-bold text-base"
                  onChange={(e) => handleChange("name", e.target.value)}
                />
              </div>

              <div className="space-y-2">
                <label className="text-[10px] text-slate-400 font-black uppercase tracking-wider block ml-1">Açıklama (İsteğe Bağlı)</label>
                <InputTextarea
                  value={category.description}
                  placeholder="Kategori hakkında kısa bir not..."
                  rows={4}
                  className="w-full border-slate-200 rounded-xl focus:border-emerald-500 py-3 shadow-sm font-medium"
                  onChange={(e) => handleChange("description", e.target.value)}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
